module.exports = __webpack_public_path__ + "static/media/Onboarding-5@1x.aae97edd.png";